import { Injectable } from '@angular/core';
import { HereTrafficService } from '@app/modules/location/services/here-traffic.service';
import { switchMap } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { Icon, LatLngBounds } from 'leaflet';
import { TranslateService } from '@livemaps/i18n';
import { Translations } from '@app/core/services/i18n/translations.service';
import { ResourceLoadState } from '@app/store/filters/models/resource-load.state';

declare var L; // eslint-disable-line no-var

export const incidentGroupOptions = {
  // Lower zoom numbers are less zoomed-in. This must be 11 as the incident API can only return max height/width of 1 degree
  minZoom: 11,
  maxZoom: 20
};

@Injectable({
  providedIn: 'root'
})
export class IncidentsService {
  private noDescriptionText: string;

  constructor(
    private hereTraffic: HereTrafficService,
    private translateService: TranslateService,
    private translations: Translations
  ) {
    this.translations.translationsLoadState
      .pipe(filter(loadstate => loadstate === ResourceLoadState.LOAD_SUCCESSFUL))
      .subscribe(() => {
        this.noDescriptionText = this.translateService.instant(this.translations.map.incidentsService.noDescription);
      });
  }

  getIcon(item: any): Icon {
    // At the moment we are just using one generic icon.
    return L.icon({
      iconUrl: 'assets/leaflet/GenericIncident.png'
    });
  }

  getTooltipContent(item: any): string {
    return item.incidentDetails?.description?.value || this.noDescriptionText;
  }

  getIncidentMarkers(bounds: LatLngBounds): Observable<object> {
    return this.hereTraffic.getIncidents(bounds).pipe(
      switchMap(incidents => {
        const markers = {};
        if (incidents && incidents.results.length) {
          const items = incidents.results;
          items.map(item => {
            if (!item.incidentDetails.originalId) {
              return;
            }

            //v7 response can contain multiple links/points outlining shape of incident - for now, we are defaulting to 0th point in 0th link
            const point = item.location.shape.links[0].points[0];
            const id = item.incidentDetails.originalId;
            const coord = new L.LatLng(point.lat, point.lng);
            const icon = this.getIcon(item);
            const mkr = L.marker(coord, { icon });
            mkr.bindPopup(this.getTooltipContent(item));
            markers[id] = mkr;
          });
        }
        return of(markers);
      })
    );
  }
}
